module.exports = __webpack_public_path__ + "static/media/UsbConnect.0cb58b05.mp4";